import { render, staticRenderFns } from "./BlogDetailHeader.vue?vue&type=template&id=12fe95b7&scoped=true"
import script from "./BlogDetailHeader.vue?vue&type=script&lang=js"
export * from "./BlogDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailHeader.vue?vue&type=style&index=0&id=12fe95b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe95b7",
  null
  
)

export default component.exports